function getNextNumber(existingCodes = [], initials = '') {
  const prefix = `${initials}-`;

  return existingCodes.reduce((highest, code) => {
    if (typeof code !== 'string' || !code.startsWith(prefix)) {
      return highest;
    }

    const numericPart = Number(code.replace(prefix, ''));
    return Number.isNaN(numericPart) ? highest : Math.max(highest, numericPart);
  }, 0) + 1;
}

export function generateRecordCode(initials, existingCodes = []) {
  const safeInitials = (initials || 'REC').toUpperCase();
  const nextNumber = getNextNumber(existingCodes, safeInitials);

  return `${safeInitials}-${String(nextNumber).padStart(3, '0')}`;
}
